import { Button, Divider, notification, Spin } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import arrowDownIcon from "../../../assets/images/arrow-down.svg";
import { getDecodedToken, getLocalStorage, setLocalStorage } from "../../../utils/localStorage";
import { getCountryIdFromMobile } from "../../../utils/helper";
import '../../onBoarding/OnBoarding.css';
import { getCities, getQualifications, getPediaDoctorDetails, updatePediaCityQualification } from "../service";
import arrowLeft from "./../../../assets/images/arrow-left.svg";
import CitySheet from "./CitySheet";
import FormField from "./FormField";
import QualificationSheet from "./QualificationSheet";
import { COUNTRY_ID_KEY, INDIAN_COUNTRY_ID } from "../../../utils/constants";

const Geographic = () => {

    const navigate = useNavigate();
    const [showCitySheet, setShowCitySheet] = useState(false);
    const [showQualificationSheet, setShowQualificationSheet] = useState(false);
    const [cities, setCities] = useState([]);
    const [qualifications, setQualifications] = useState([]);
    const [selectedCity, setSelectedCity]: any = useState({});
    const [selectedQualification, setSelectedQualification]: any = useState({});
    const [selectedQualifications, setSelectedQualifications]: any = useState([]);
    const [email, setEmail] = useState('');
    const [loader, setLoader] = useState(false);
    const tokenData: any = getDecodedToken();
    const doctorDetails: any = tokenData?.user || {};
    const [continueLoading, setContinueLoading] = useState(false);
    const [qualificationIds, setQualificationIds]: any = useState([]);
    const { promoCode } = useLocation().state || {};

    const handleCityClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        openCitySheet();
    };

    const getDoctorCities = async () => {
        const cid = getLocalStorage(COUNTRY_ID_KEY) || INDIAN_COUNTRY_ID;
        const res: any = await getCities("", cid);
        if (res?.status === 200) setCities(res?.data);
    };
    const getDoctorQualifications = async () => {
        const cid = getLocalStorage(COUNTRY_ID_KEY) || INDIAN_COUNTRY_ID;
        const res: any = await getQualifications("", promoCode || "", cid);
        if (res?.status === 200) setQualifications(res?.data);
    };

    const handleQualificationClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        openQualificationSheet();
    };

    const openCitySheet = () => {
        setShowCitySheet(true);
    };

    const openQualificationSheet = () => {
        setShowQualificationSheet(true);
    };

    const closeCitySheet = () => {
        setShowCitySheet(false);
    };

    const closeQualificationSheet = () => {
        setShowQualificationSheet(false);
    };


    const handleCity = (city: any) => {
        setSelectedCity(city);
        closeCitySheet();
    };

    const handleQualification = (q: any) => {
        setSelectedQualification(q);


        const qualis = selectedQualifications;
        qualis.push(q);
        // filter duplicates
        const uniqueItems = qualis.filter((value: any, index: any, self: any) => {
            return index === self.findIndex((t: any) => t.id === value.id);
        });
        setSelectedQualifications(uniqueItems);

        // closeQualificationSheet();
    };

    const continueBtnHandler = async () => {
        setContinueLoading(true);
        const res: any = await updatePediaCityQualification(
            {
                city_id: selectedCity?.id,
                // qualification_id: selectedQualification?.id,
                mbl_no: doctorDetails?.mobileNumber,
                email: email,
                // qualification_ids: qualificationIds
                qualification_ids: selectedQualifications?.map((value: any) => value.id),
            });
        if (res?.status === 200) {
            setContinueLoading(false);
            notification.success({ message: 'Profile details updated!' });
            navigate("/");
        }
    };

    const removeQualification = (id: any) => {

        const qualis = selectedQualifications.filter((item: any) => item.id !== id);
        setSelectedQualifications(qualis);

    };

    const removeQualificationByCode = (code: any) => {
        const qualis = selectedQualifications.filter((item: any) => item.code !== code);
        setSelectedQualifications(qualis);
    };

    useEffect(() => {
        setLoader(true);
        const load = async () => {
            // Same as /profile: fetch doctor details, derive countryId from mobile, set localStorage
            if (doctorDetails?.mobileNumber) {
                try {
                    const res: any = await getPediaDoctorDetails(doctorDetails.mobileNumber);
                    if (res?.status === 200 && res?.data?.body) {
                        const b = res.data.body;
                        const cid = getCountryIdFromMobile(b.mobile_number || doctorDetails.mobileNumber);
                        if (cid != null) setLocalStorage(COUNTRY_ID_KEY, cid);
                    }
                } catch (_) {}
            }
            // Then getDoctorCities and getDoctorQualifications read from localStorage (same as /profile)
            getDoctorCities();
            getDoctorQualifications();
        };
        load().finally(() => setLoader(false));
    }, []);


    return (
        loader ? (
            <div className="flex justify-center items-center w-full min-h-screen">
                <Spin size="default" />
            </div>
        ) : (
            <>
                <div className="flex flex-col justify-between h-full">
                    <div className="flex flex-col items-start p-6">
                        <img
                            className="me-0"
                            height={22}
                            width={22}
                            src={arrowLeft}
                            alt="Youtube"
                            onClick={() => navigate("/")}
                        />
                        <div className="text-left text-lg xs:text-xl xsPlus:text-2xl font-semibold pb-4 pt-4">
                            Please enter below details
                        </div>
                    </div>

                    <form className="flex flex-col self-center w-full px-6">
                        <div className="flex flex-col self-center w-full">
                            <label
                                htmlFor="city"
                                className="flex-1 shrink gap-2.5 px-2 w-full text-sm leading-loose text-gray-500 text-left"
                            >
                                City <span className="text-red-500">*</span>
                            </label>
                            <div
                                className="flex items-center mt-1 w-full text-base text-gray-500 bg-white rounded-xl border border-solid border-slate-300 min-h-[56px]">
                                <div
                                    onClick={handleCityClick}
                                    className="flex flex-1 shrink gap-2 justify-between items-center px-3 py-2 basis-0 min-w-[240px] size-full"
                                >
                                    <span>
                                        {selectedCity?.cityName !== undefined ? selectedCity?.cityName + ', ' + selectedCity?.state : "Select City"}
                                    </span>
                                    <img loading="lazy" src={arrowDownIcon} alt="Arrow Down" />
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col self-center mt-3 w-full">
                            <label
                                htmlFor="qualification"
                                className="flex-1 shrink gap-2.5 px-2 w-full text-sm leading-loose text-gray-500 text-left"
                            >
                                Qualification <span className="text-red-500">*</span>
                            </label>
                            <div
                                className="flex items-center mt-1 w-full text-base text-gray-500 bg-white rounded-xl border border-solid border-slate-300 min-h-[56px]">
                                <div
                                    className="flex flex-1 shrink gap-2 justify-between items-center px-3 py-2 basis-0 min-w-[240px] size-full"
                                >
                                    <span className={'text-left'}>
                                        {selectedQualifications.length > 0 ? selectedQualifications.map((q: any) => (
                                            <span id={q.id} onClick={() => removeQualification(q.id)}
                                                className={'quali-button'}>{q.code} &times;</span>)) : "Select Qualifications"}
                                    </span>
                                    <img onClick={handleQualificationClick} loading="lazy" src={arrowDownIcon}
                                        alt="Arrow Down" />
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col self-center mt-3 w-full">
                            <FormField
                                label={'Email'}
                                value={email || ""}
                                onChange={(e) => setEmail(e)}
                                placeholder="Enter your email id (optional)"
                            /></div>
                        <div className="w-full absolute bottom-6 left-0">
                            <div className="flex flex-col items-center max-w-[1280px] w-full">
                                <Divider />
                                <Button
                                    type="primary"
                                    className="w-[85%] h-14 rounded-2xl bg-[#4B4AD5] p-5 text-lg font-medium"
                                    onClick={continueBtnHandler}
                                    disabled={!(selectedCity?.id !== undefined && selectedQualifications?.length > 0)}
                                    loading={continueLoading}
                                >
                                    Continue
                                </Button>
                            </div>
                        </div>

                    </form>
                </div>
                <CitySheet
                    show={showCitySheet}
                    cities={cities}
                    closePopup={closeCitySheet}
                    handleCity={handleCity}
                />
                <QualificationSheet
                    show={showQualificationSheet}
                    qualifications={qualifications}
                    closePopup={closeQualificationSheet}
                    handleQualification={handleQualification}
                    selectedQualifications={selectedQualifications}
                    removeQualificationByCode={removeQualificationByCode}
                />
            </>
        )
    );

}

export default Geographic;